import React, {useEffect, useState} from 'react'
import Skeleton from 'react-loading-skeleton'
import { Title } from 'utils/Title'
import PageMainHeader from 'components/PageMainHeader'
import { AuthContext } from "contexts/AuthContext"
import { SettingsContext } from 'contexts/SettingsContext'
import Banner from '@leafygreen-ui/banner'
import PageMenuHeader from 'components/PageMenuHeader'
import moment from "moment";
import _ from "lodash";
import { fetchPackingItems, updateManyPackingItem  } from 'utils/packingItems';
import { updateOrder } from 'utils/orders'
import { jsonToCSV } from "react-papaparse";
import "react-toastify/dist/ReactToastify.css";
import { useMutation, useQuery, useQueryClient } from "react-query";
import FileImportExport from 'components/FileImportExport'
import { Table, TableHeader, Row, Cell } from '@leafygreen-ui/table'
import { FaBold, FaCheck } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { ModalPreloader } from 'utils/Preloader'
import Pagination from 'utils/Pagination'
import ScrollTop from 'utils/ScrollTop'
import { errorHandler } from 'utils/errorHandler'
import Search from 'components/Search'
import { Option, Select } from "@leafygreen-ui/select";
import { assignBin } from 'utils/bins'
import { FaBolt } from "react-icons/fa";
import Button from "@leafygreen-ui/button";
import axios from 'axios';

const title="Packing List";

const pageSize = 50

export default function PackingList() {
  const [page, setPage] = React.useState(1);
  const { settings } = React.useContext(SettingsContext);
  const { user } = React.useContext(AuthContext);
  const [loading, setLoading] = React.useState(false);
  const [msg, setMsg] = React.useState(null);
  const [selectedExportMode, setSelectedExportMode] = React.useState("retrieved");
  const queryClient = useQueryClient();
  const [printStates] = React.useState(null)
  const [searchTxt, setSearchTxt] = useState(null);
  const [selectedSearchOption, setSelectedSearchOption] = useState("orderNumber");
  const locationCodeRef = React.useRef(null);
  
  useEffect(() => {
    if(user && user?.locationCode) locationCodeRef.current = user.locationCode;
  }, [user])
  
  const { data: packingItems, isLoading, isError, error, refetch: refetchPackingItems } = useQuery(
    ["packingitems", page],
    () => fetchPackingItems({isActive: true, page, limit: pageSize, locationCode: locationCodeRef.current}),
    // {enabled: false}
  );
  // console.log('- packingItems: ', packingItems)

  useEffect(() => {
    packingItems && console.log("* packingItems in hook: ");
    // console.log('- page: ', page)
    console.log('- searchTxt: ', searchTxt)
    if(_.isNil(searchTxt)) {
      if (packingItems && packingItems?.totalPages > page) {
        console.log('- prefetchQuery init')
        queryClient.prefetchQuery(
          ["packingitems", page + 1],
          () => fetchPackingItems({isActive: true, page: page + 1, limit: pageSize}),
          {
            keepPreviousData: true,
            refetchOnWindowFocus: false,
            staleTime: 1000 * 60 * 5,
          }
        );
      }

    }
    // eslint-disable-next-line
  }, [page, packingItems, queryClient, searchTxt]);

  const exportPackingItems = async () => {
    console.log("* exportPackingItems init");
    console.log("[exportPackingItems] selectedExportMode: ", selectedExportMode);
    let temp = []

    if (selectedExportMode === "all") {
      temp = await fetchPackingItems({isActive: true})
    } else {
      temp = _.cloneDeep(packingItems.docs);
    }
    if(settings?.useManualOrderCreation) {
      //get orders which order items are empty, 
      let orderItemsNotExistOrders = [];
      if(window?.printflo_api) {
        await window.printflo_api._getManualOrders()
          .then(result => {
            if(Boolean(result.length)) {
              orderItemsNotExistOrders = result;
            }
          })
      } else {
        await axios.get('/api/orders/fetch-manual-orders')
        .then(result => {
          if(Boolean(result?.data.length)) {
            orderItemsNotExistOrders = result.data
          }
        })
      }
      console.log("[exportPackingItems] orderItemsNotExistOrders: ", orderItemsNotExistOrders)
      temp = temp.concat(orderItemsNotExistOrders)
    }
    
    console.log('[exportPackingItems] temp: ', temp)

    const selectedKeys = [
      "orderId",
      "orderNumber",
      "sku",
      "isBundle",
      "quantity",
      "sequence",
      "count",
      "checkedOutQty",
      "pickedQty",
    ];

    const result = jsonToCSV({
      fields: selectedKeys,
      data: temp
    });
    // console.log(result);

    const element = document.createElement("a");
    const file = new Blob([result], {
      type: "text/csv",
    });
    element.href = URL.createObjectURL(file);
    element.download = `packingitems_${moment().format("YYYYMMDDHHmm")}.csv`;
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
    setSelectedExportMode('retrieved');
  };

  const inActivatePackingItems = (orderIds) => {
    console.log("* inActivatePackingItems init")
    return new Promise((resolve, reject) => {
      console.log("[inActivatePackingItems] orderIds: ", orderIds);
      const promises = orderIds.map(async (orderId) => {
        return await updateManyPackingItem({
          condition: { orderId },
          update: { $set: { isActive: false } },
        })
      })

      Promise.all(promises)
      .then(results => resolve(results))
      .catch(error => {
        console.error("[inActivatePackingItems] error: ", errorHandler(error));
        reject(errorHandler(error))
      })
      
    });
  };

  const importPackingItems = async (parsedData) => {
    console.log('* importPackingItems init')
    setLoading(true);
    console.log('[importPackingItems] parsedData: ', parsedData)

    let tempItems = parsedData.map((item) => item.data);
    // console.log("tempItems", tempItems);
    //delete packing items from orderId of tempItems
    const tempGroupByOrderId = _.groupBy(tempItems, "orderId");
    console.log("[importPackingItems] tempGroupByOrderId: ", tempGroupByOrderId);
    let orderIds = [];
    for (let orderId in tempGroupByOrderId) {
      orderIds.push(orderId);
      let groupedOrder = tempGroupByOrderId[orderId];
      const sumQty = _.sumBy(groupedOrder, (order) => {
        let qty = 0
        qty = qty + parseInt(order.quantity)
        return qty 
      });
      // console.log("[importPackingItems] groupedOrder", groupedOrder);
      // console.log("[importPackingItems:groupedOrder] sumQty: ", sumQty);

      // console.log(orderId, typeof orderId);
      // checking BIN and sumQty
      const found = _.find(printStates, { orderId: parseInt(orderId) });
      // console.log("[importPackingItems] found: ", found);
      if (found) {
        if(settings?.binAssignmentType !== 'hanger') {
          if (_.isNil(found?._order?.bin) && sumQty > 1) {
            //assign Bin to order and save bincode to bin
            await assignBin(orderId, sumQty)
              .then((res) => {
                console.log("assignBin result", res);
                setMsg(`Assigned Bin to ${orderId}`);
              })
              .catch((error) => {
                console.log("assignBin request error", error);
                setMsg(`Assign Bin error for ${orderId}`);
              });
          }
        }  
      } else {
        if(settings?.binAssignmentType !== 'hanger') {
          if(sumQty > 1) {
            await assignBin(orderId, sumQty)
              .then((res) => {
                console.log("[importPackingItems:assignBin] result", res);
                setMsg(`Assigned Bin to ${orderId}`);
              })
              .catch((error) => {
                console.log("[importPackingItems:assignBin] error", error);
                setMsg(`Assign Bin error for ${orderId}`);
              });
          } else {
            await updateOrder({
              condition: { orderId },
              update: { bin: null, quantity: sumQty },
            })
          }
        } else {
          await assignBin(orderId, 1)
        }
        
      }
    }

    // console.log("- after loop orderIds", orderIds);

    await inActivatePackingItems(orderIds)
      .then((result) => {
        console.log("inActivatePackingItems result: ", result);
        setMsg("In-Activating related packing items...");
      })
      .catch((error) => {
        console.log("inActivate PackingItems error", error);
        const retVal = errorHandler(error)
        setMsg(retVal);
        return;
      });

    setMsg(`Total number of packing items: ${tempItems.length}`);

    let i = 0;
    let len = tempItems.length - 1;

    async function loop() {
      console.log(i, tempItems[i]);
      let itm = tempItems[i];
      itm['orderItemId'] = Math.floor(Math.random()*10000000).toString()

      console.log(i, itm);
      let result;

      try {
        if (window?.printflo_api) {
          result = await window.printflo_api._importPackingItems({...itm});
        } else {
          const response = await axios.post(`/api/packing-items/import`, { item: itm });
          result = response?.data;
        }
        console.log("[importPackingItems] result: ", result)
        setMsg(`${i + 1}/${tempItems.length}: ${result?.sku} updated.`);
        i += 1;
      } catch (error) {
        console.log("submit item error", error);
        setMsg(`Error occured, try again from this sku: ${itm.sku}`);
        return;
      }

      if (i <= len && _.has(tempItems[i], "sku")) {
        loop();
      } else {
        setMsg("* Completed import packing items");
        setLoading(false);
        window.location.reload();
        return;
      }
    }

    if (i <= len) {
      loop();
    }
  };

  const handleOnPageChange = ({ selected }) => {
    console.log("- handleOnPageChange init")
    console.log('[handleOnPageChange] selected: ', selected); 
    console.log('[handleOnPageChange] page: ', page, selected+1); 
    if((selected+1) !== page) {
      setPage(selected + 1);
    }
  };

  const fetchSearchResults = useMutation(
    async (searchTxt) => {
      console.log("* fetchSearchResults init");
      console.log("[fetchSearchResults] searchTxt: ", searchTxt);
      console.log("[fetchSearchResults] selectedSearchOption: ", selectedSearchOption);
      setLoading(true);
      // let args = {}
      let args = {page, limit: pageSize}
      args[selectedSearchOption] = searchTxt
      console.log('[fetchSearchResults] args: ', args)
      return await fetchPackingItems({...args});
    },
    {
      onError: (error) => {
        const retval = errorHandler(error);
        setMsg(retval);
        setLoading(false);
      },
      onSuccess: (result) => {
        console.log("[fetchSearchResults:onSuccess] result: ", result);
        queryClient.setQueryData(["packingitems", page], () => {
          return { ...result };
        });
        // setLimit(result?.limit)
        setLoading(false);
      },
    }
  );

  const handleSearch = async (searchTxt) => {
    console.log("* handleSearch init");
    console.log("searchTxt", searchTxt);
    if (!_.isEmpty(searchTxt)) {
      if (page > 1) {
        alert("Requried to move page 1");
        return;
      }
      setSearchTxt(searchTxt);
      fetchSearchResults.mutate(searchTxt);
    }
  };

  const onChangeLocationCodeHander = (v) => {
    console.log("* onChangeLocationCodeHander init");
    console.log("[onChangeLocationCodeHander] v: ", v);
    if(v==="all") v = null;
    locationCodeRef.current = v;
    console.log("[onChangeLocationCodeHander] locationCode: ", locationCodeRef)
    refetchPackingItems();
  }

  return <>
      <Title title={title} />
      <PageMainHeader 
        title={title} 
        user={user} 
        settings={settings} 
      />
      <section className="primary">
        {isLoading ? (
          <Skeleton count={20} height={50} circle={true} />
        ) : isError ? (
          <Banner variant='danger'>{error?.message ? error.message : error}</Banner>
        ) : (
          null
        )}
        <PageMenuHeader>
          <div className='d-flex'>
            <Button
            variant="primary"
            className="swing-icon"
            title="Reload"
            leftGlyph={<FaBolt />}
            onClick={() => {
              window.location.reload();
            }}
          >
            Refresh
          </Button>
            <FileImportExport 
              importHandler={importPackingItems}
              exportHandler={exportPackingItems}
              selectedExportMode={selectedExportMode}
              setSelectedExportMode={setSelectedExportMode}
            />
          </div>
          <div className="align-right_container">
            {(settings?.useMultipleLocations && settings?.locations) && (
              <div className="input-field location-container align-items-center">
                <label htmlFor="locationCode" className="mr-10">Location:</label>
                <Select
                  value={locationCodeRef?.current ? locationCodeRef.current : 'all'}
                  onChange={(value) => onChangeLocationCodeHander(value)}
                  className="select-location"
                  placeholder="Location Options"
                  aria-labelledby="Location options"
                >
                  <Option value="all">All</Option>
                  {settings?.locations.map((location) => {
                    return (
                      <Option key={location?.code} value={location?.code}>
                        {location.name}
                      </Option>
                    );
                  })}
                </Select>
              </div>
            )}

            <Select
              className="search-select"
              onChange={(value) => {
                console.log("- onChange args:", value);
                setSelectedSearchOption(value);
              }}
              value={selectedSearchOption}
              placeholder="Search Options"
              aria-labelledby="Search options"
            >
              <Option value="orderNumber">Order Number</Option>
              <Option value="sku">SKU</Option>
              <Option value="bin">Bin</Option>
            </Select>
            <Search handleSearch={handleSearch} />

          </div>

        </PageMenuHeader>

        {packingItems?.totalPages > 1 && (
          <Pagination 
            handleOnPageChange={handleOnPageChange} 
            totalDocs={packingItems.totalDocs} 
            totalPages={packingItems.totalPages} 
            page={page} 
            limit={pageSize}
          />
        )}

        {msg && (
          <Banner className='mb-10'>{msg}</Banner>
        )}

        {packingItems?.docs && 
          <Table
            data={packingItems.docs}
            columns={[
              <TableHeader label="Status" />,
              <TableHeader label="Bin" />,
              <TableHeader label="Order Number" />,
              <TableHeader label="SKU" />,
              <TableHeader label="Pretreatment Barcdoe"  className={settings?.usePretreatmentBarcode ? "" : 'hidden'}/>,
              <TableHeader label="Ordered" />,
              <TableHeader label="Picked" />,
              <TableHeader label="Printed" />,
              <TableHeader label="Checked Out" />,
              <TableHeader label="Order Date" />,
              <TableHeader label="Synced At" />,
              // <TableHeader label="QR Code" />,
            ]}
          >
            {({datum}) => (
              <Row key={datum._id}>
                <Cell>
                  {datum.quantity === datum.checkedOutQty && (
                    <FaCheck />
                  )}
                </Cell>
                <Cell>
                  {datum?._order?.bin ? datum._order.bin : ""}
                </Cell>
                <Cell>
                  <Link to={`workorder-details/${datum?.orderId}`}>
                    <span className='block'>
                      {datum.orderNumber}
                      {datum.isBundle && (
                        <span><FaBold size="10px" color="#007CAD" className='ml-10' /></span>
                      )}
                    </span>
                  </Link>

                  <span className="block">
                    {datum.sequence} / {datum.count}
                  </span>

                </Cell>
                <Cell>{datum?.sku ? datum.sku : ""}</Cell>
                <Cell className={settings?.usePretreatmentBarcode ? "" : 'hidden'}>{datum?._item?.pretreatmentBarcode ? datum._item.pretreatmentBarcode : ""}</Cell>
                <Cell>{datum?.quantity ? datum.quantity : 0}</Cell>
                <Cell>{datum?.pickedQty ? datum.pickedQty : 0}</Cell>
                <Cell>{datum?.printed ? _.sumBy(datum.printed, "qty") : 0}</Cell>
                <Cell>{datum?.checkedOutQty ? datum.checkedOutQty : 0}</Cell>
                <Cell>{datum?._order?.orderDate ? moment(datum._order.orderDate).format("MM-DD-YYYY") : ""}</Cell>
                <Cell>{datum?.createdAt ? moment(datum.createdAt).format("MM-DD-YYYY") : ""}</Cell>
                {/* <Cell>{<QRCode value={datum.sku+'*'+datum.orderId} size={50} level='Q'/>}</Cell> */}
              </Row>
            )}
          </Table>
        }
        <ModalPreloader modalPreloaderIsOpen={loading} />
        <ScrollTop />
        {/* <pre>{JSON.stringify(printStates, null, 2)}</pre> */}

      </section>
    </>
}
